import './CookiesAgreement/CookiesAgreement';
import './MarqueeText/MarqueeText';
// import './Collapse/Collapse';
import './LitPopupElement/LitPopupElement';
import './Upload/Upload';
import { YandexMap } from './YandexMap/YandexMap';

customElements.define('app-yandex-map', YandexMap);
